import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import { motion } from "framer-motion";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
// import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, get, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "core/Operations/toast";
import { Popconfirm } from "antd";
import { useInsertProjectMutation } from "AppQuries/project/project";
import { projectCreationValidationSchema } from "core/Operations/ValidationSchema/projectValidationSchema";
import { ProjectInformationMapping } from "./Tab/ProjectInformationMapping";
import ProjectInformation from "./Tab/ProjectInformation";
import ClinetInformation from "./Tab/ClientInformation";
import ApprovalInfo from "./Tab/ApprovalInfo";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
import { BackIcon } from "Components/UI/Icon/Icons";

const steps = [
  { id: 0, name: "Information", component: ProjectInformation },
  { id: 1, name: "Client Details", component: ClinetInformation },
  { id: 2, name: "Approval Info", component: ApprovalInfo },
  // { id: 3, name: "Employees", component: Employee },
  // { id: 4, name: "Accident", component: VehicleAccident },
  // { id: 5, name: "Indemnity", component: VehicleIndemnity },
];

const AddProject = () => {
  const userData = useSelector(loggedInUser);
  const [step, setStep] = useState(0);
  const {
    mutate: addProject,
    isPending,
    isError,
    error,
  } = useInsertProjectMutation();

  const projectMethods = useForm({
    defaultValues: {
      id: 0,
      companyCode: userData.companyCode,
      projectCode: "",
      projectName: "",
      projectStartDay: "",
      projectEndDay: "",
      projectStatus: "",
      approvedBy: "",
      groupCode: "",
      shiftCode: "",
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
      remarks: "",
      locationCode: userData.locationCode,
      type: 0,
      department: 0,
      clientProjectCode: 0,
      team: "",
      abbreviation: "",
      projectDescription: "",
      clientDetails: {
        id: 0,
        companyCode: userData.companyCode,
        locationCode: "",
        projectCode: "",
        clientCompany: "",
        mainContact: "",
        contact2: "",
        remarks: "",
        clientProjectCode: 0,
        address: "",
        email: "",
        email2: "",
        clientProjectAbbr: "",
        isActive: true,

        createdBy: userData?.userName,
        createdDate: getCurrentFormattedDate(),
        modifiedBy: userData?.userName,
        modifiedDate: getCurrentFormattedDate(),
      },
      approvalDetails: {
        id: 0,
        companyCode: userData.companyCode,
        locationCode: "",
        projectCode: "",
        modeOfApproval: "",
        clientWORefNo: "",
        clientContractNo: "",
        attachWO: "",
        workOrderMode: "",
        hardcopyReceived: true,
        remarks: "",
        technicalDetails: "",
        latitude: 0,
        longitude: 0,
        commercialDetails: "",
        quotationTemplate: "",
        quoteKey: "",
        minimumManday: 0,
        estimatedManHours: 0,
        estimatedManHourCost: 0,
        estimatedMaterialCost: 0,
        isActive: true,
        createdBy: userData?.userName,
        createdDate: getCurrentFormattedDate(),
        modifiedBy: userData?.userName,
        modifiedDate: getCurrentFormattedDate(),
      },
      projectsDetails: [
        {
          id: 0,
          companyCode: userData.companyCode,
          projectCode: "",
          employeeCode: 0,
          createdBy: userData?.userName,
          createdDate: getCurrentFormattedDate(),
          modifiedBy: userData?.userName,
          modifiedDate: getCurrentFormattedDate(),
          isActive: true,
        },
      ],
    },
    resolver: yupResolver(projectCreationValidationSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
    watch,
  } = projectMethods;

  const StepComponent = steps[step].component;

  const moveTo = async (id) => {
    setStep(id);
  };

  const onSubmit = (payload) => {
    const projectsDetails = payload.selectedEmployees?.map((emp) => ({
      id: 0,
      companyCode: userData?.companyCode,
      projectCode: "0",
      employeeCode: emp,
      createUser: userData?.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    }));

    delete payload.selectedEmployees;

    payload.projectsDetails = projectsDetails;

    addProject([payload], {
      onSuccess: (data) => {
        if (data) {
          toast.success(data?.message || "Project Created Successfully.");
          setTimeout(() => {
            navigate(`${all_routes.project}${all_routes.project_list}`);
          }, 1000);
        } else {
          toast.warning(data?.message || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const onError = (errors) => {
    console.log("errors onError", errors);
    // Get the first field with error
    const firstErrorField = Object.keys(errors)[0];
    const tabIndex = ProjectInformationMapping[firstErrorField];

    if (tabIndex !== undefined) {
      setStep(tabIndex);
    }
  };

  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...projectMethods}>
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Project Details</h4>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save Project</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Popconfirm
                      title="Are you sure to go back before saving?"
                      onConfirm={() =>
                        navigate(
                          `${all_routes.project}${all_routes.project_list}`
                        )
                      }
                    >
                      <button type="button" className="btn btn-secondary">
                        <BackIcon className="me-2" />
                        Back
                      </button>
                    </Popconfirm>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-solid nav-justified mb-3">
                        {steps?.map((item, index) => (
                          <li className="nav-item me-0" key={item.id}>
                            <Link
                              className={`nav-link step-${item.id} py-1 ${
                                index === step
                                  ? "active"
                                  : index < step
                                  ? "completed"
                                  : "in-completed"
                              }`}
                              id={item.id}
                              type="button"
                              // disabled
                              onClick={() => moveTo(item.id)}
                            >
                              {/* <motion.div
                                className={`w-10 h-10 mx-auto flex items-center justify-center font-bold rounded-full transition`}
                                initial={{ scale: 0.9 }}
                                animate={{ scale: index === step ? 1.1 : 1 }}
                                transition={{ duration: 0.9 }}
                              > */}
                              {item.name}
                              {/* </motion.div> */}
                            </Link>
                          </li>
                        ))}
                      </ul>
                      <div className="tab-content">
                        <motion.div
                          key={step}
                          initial={{ opacity: 0, x: 50 }}
                          animate={{ opacity: 1, x: 0 }}
                          exit={{ opacity: 0, x: -50 }}
                          transition={{ duration: 0.3 }}
                        >
                          <div className="tab-pane text-editor add-list">
                            <StepComponent userData={userData} />
                          </div>
                        </motion.div>
                        {/* <div className="tab-pane show active" id="tab1">
                          <Vehicle companyCode={userData?.companyCode} />
                        </div>
                        <div className="tab-pane" id="tab2">
                          <VehicleExpenses />
                        </div>
                        <div className="tab-pane" id="tab3">
                          <VehicleMaintenance />
                        </div>
                        <div className="tab-pane" id="tab4">
                          <DieselUsage />
                        </div>
                        <div className="tab-pane" id="tab5">
                          <VehicleAccident />
                        </div>
                        <div className="tab-pane" id="tab6">
                          <VehicleIndemnity />
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddProject;

// import React, { useState } from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { ArrowLeft, Save } from "react-feather";
// import { useSelector } from "react-redux";
// import { loggedInUser } from "core/redux/slice/authSlice";
// import { FormProvider, useForm } from "react-hook-form";
// import { format } from "date-fns";
// import { yupResolver } from "@hookform/resolvers/yup";
// import Error404 from "MainPages/ErrorPages/error404";
// import { all_routes } from "Router/all_routes";
// import { Link, useNavigate } from "react-router-dom";
// import ProjectForm from "Components/Form/ProjectForm";
// import { message } from "antd";
// import { useInsertProjectMutation } from "AppQuries/project/project";
// import { projectCreationValidationSchema } from "core/Operations/ValidationSchema/projectValidationSchema";
// import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
// import { toast } from "core/Operations/toast";
// const AddProject = () => {
//   const userData = useSelector(loggedInUser);
//   const {
//     mutate: addProject,
//     isPending,

//     isError,
//     error,
//   } = useInsertProjectMutation();
//   const methods = useForm({
//     defaultValues: {
//       id: 0,
//       companyCode: userData.companyCode,
//       locationCode: userData.locationCode,
//       createUser: userData?.userName,
//       createDate: getCurrentFormattedDate(),
//       modifyUser: userData?.userName,
//       modifyDate: getCurrentFormattedDate(),
//       isActive: true,
//     },
//     resolver: yupResolver(projectCreationValidationSchema),
//     shouldFocusError: false,
//   });

//   const navigate = useNavigate();

//   const {
//     handleSubmit,
//     formState: { errors },
//   } = methods;

//   const onSubmit = (payload) => {
//     const projectsDetails = payload?.selectedEmployees?.map((emp) => ({
//       id: 0,
//       companyCode: userData?.companyCode,
//       projectCode: "",
//       employeeCode: emp,
//       createUser: userData?.userName,
//       createDate: getCurrentFormattedDate(),
//       modifyUser: userData?.userName,
//       modifyDate: getCurrentFormattedDate(),
//       isActive: true,
//       locationCode : userData?.locationCode
//     }));

//     delete payload.selectedEmployees;
//     payload.projectsDetails = projectsDetails;
//     const requestData = [{ ...payload }];
//     console.log(requestData);
//     addProject(requestData, {
//       onSuccess: (data) => {
//         if (data === true) {
//           toast.success("Project Added Successfully.");
//           setTimeout(() => {
//             navigate(`${all_routes.project}${all_routes.project_list}`);
//           }, 1000);
//         } else {
//           toast.danger(data?.[0]?.errorMessage || "Something went wrong.");
//         }
//       },
//       onError: (error) => {
//         toast.danger(error.message || "Something went wrong.");
//       },
//     });
//   };
//   if (isError) return <Error404 error={error} />;
//   return (
//     <div>
//       <div className="page-wrapper">
//         <FormProvider {...methods}>
//           <form onSubmit={handleSubmit(onSubmit)}>
//             <div className="content">
//               <div className="page-header">
//                 <div className="add-item d-flex">
//                   <div className="page-title">
//                     <h4>Add New Project</h4>
//                     <h6>Add your new Project </h6>
//                   </div>
//                 </div>
//                 <div className="page-btn">
//                   <OverlayTrigger
//                     placement="top"
//                     overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
//                   >
//                     <Link
//                       to={`${all_routes.project}${all_routes.project_list}`}
//                       className="btn btn-secondary"
//                     >
//                       {/* <ArrowLeft className="me-2" /> */}
//                       Back
//                     </Link>
//                   </OverlayTrigger>
//                 </div>
//                 <div className="page-btn">
//                   <OverlayTrigger
//                     placement="top"
//                     overlay={
//                       <Tooltip id="add-new-tooltip">Save Project</Tooltip>
//                     }
//                   >
//                     <button type="submit" className="btn btn-added">
//                       <Save className="me-2" />
//                       Save
//                     </button>
//                   </OverlayTrigger>
//                 </div>

//               </div>
//               <div className="row">
//                 <div className="col-md-12">
//                   <div className="card border-0">
//                     {/* <div className="card-header">
//                       <h4 className="card-title">Add Project</h4>
//                     </div> */}
//                     <div className="card-body">
//                       <ProjectForm mode="A" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </FormProvider>
//       </div>
//     </div>
//   );
// };

// export default AddProject;
